import { render, staticRenderFns } from "./VentureList.vue?vue&type=template&id=359f7028&scoped=true"
import script from "./VentureList.vue?vue&type=script&lang=js"
export * from "./VentureList.vue?vue&type=script&lang=js"
import style0 from "./VentureList.vue?vue&type=style&index=0&id=359f7028&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359f7028",
  null
  
)

export default component.exports